import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/icon_filter.svg'
import _imports_1 from '@/assets/icons/icon_perfil_red.svg'
import _imports_2 from '@/assets/icons/icon_advertiser_HiOutlineSpeakerphone.svg'
import _imports_3 from '@/assets/icons/status/icon_status_approved_Vector.svg'
import _imports_4 from '@/assets/icons/status/icon_status_approving_HiClock.svg'
import _imports_5 from '@/assets/icons/status/icon_status_canceled_HiXCircle.svg'
import _imports_6 from '@/assets/icons/status/icon_status_requested_adjustments_HiExclamation.svg'
import _imports_7 from '@/assets/icons/status/icon_status_edit.svg'
import _imports_8 from '@/assets/icons/status/icon_status_rascunho.svg'
import _imports_9 from '@/assets/icons/status/icon_status_published.svg'
import _imports_10 from '@/assets/icons/status/icon_status_completed.svg'
import _imports_11 from '@/assets/icons/status/icon_status_active.svg'
import _imports_12 from '@/assets/icons/status/icon_status_pending_publication.svg'
import _imports_13 from '@/assets/icons/status/icon_status_historico.svg'
import _imports_14 from '@/assets/icons/icon_IoEllipsisVerticalCircleOutline.svg'


const _hoisted_1 = {
  id: "div-pesquisa-campanha",
  class: "row q-pb-lg"
}
const _hoisted_2 = { class: "row fit no-wrap justify-between items-end content-start" }
const _hoisted_3 = {
  class: "col-grow",
  style: {"overflow":"auto"}
}
const _hoisted_4 = { style: {"position":"relative"} }
const _hoisted_5 = {
  class: "q-pl-md",
  style: {"overflow":"auto"}
}
const _hoisted_6 = {
  id: "div-table-campanha",
  class: "row justify-center q-gutter-sm"
}
const _hoisted_7 = { style: {"width":"100%"} }
const _hoisted_8 = { class: "midia-app-title-header-table-lg" }
const _hoisted_9 = { class: "row items-center no-wrap" }
const _hoisted_10 = { class: "midia-app-label-lg q-pl-md" }
const _hoisted_11 = { class: "row items-center" }
const _hoisted_12 = { class: "midia-app-label-lg" }
const _hoisted_13 = { class: "row items-center" }
const _hoisted_14 = { class: "midia-app-label-lg" }
const _hoisted_15 = { class: "row items-center" }
const _hoisted_16 = { class: "midia-app-label-lg" }
const _hoisted_17 = { class: "row items-center" }
const _hoisted_18 = { class: "midia-app-label-lg" }
const _hoisted_19 = { class: "row items-center" }
const _hoisted_20 = { class: "row items-center justify-center" }
const _hoisted_21 = {
  key: 0,
  class: "svg-icon",
  src: _imports_3
}
const _hoisted_22 = {
  key: 1,
  class: "svg-icon",
  src: _imports_4
}
const _hoisted_23 = {
  key: 2,
  class: "svg-icon",
  src: _imports_5
}
const _hoisted_24 = {
  key: 3,
  class: "svg-icon",
  src: _imports_6
}
const _hoisted_25 = {
  key: 4,
  class: "svg-icon",
  src: _imports_7
}
const _hoisted_26 = {
  key: 5,
  class: "svg-icon",
  src: _imports_8
}
const _hoisted_27 = {
  key: 6,
  class: "svg-icon",
  src: _imports_9
}
const _hoisted_28 = {
  key: 7,
  class: "svg-icon",
  src: _imports_7
}
const _hoisted_29 = {
  key: 8,
  class: "svg-icon",
  src: _imports_4
}
const _hoisted_30 = {
  key: 9,
  class: "svg-icon",
  src: _imports_6
}
const _hoisted_31 = {
  key: 10,
  class: "svg-icon",
  src: _imports_3
}
const _hoisted_32 = {
  key: 11,
  class: "svg-icon",
  src: _imports_10
}
const _hoisted_33 = {
  key: 12,
  class: "svg-icon",
  src: _imports_11
}
const _hoisted_34 = {
  key: 13,
  class: "svg-icon",
  src: _imports_12
}
const _hoisted_35 = {
  key: 14,
  class: "svg-icon",
  src: _imports_13
}
const _hoisted_36 = { class: "div-container-action-icons" }
const _hoisted_37 = { style: {"display":"flex","flex-direction":"column","gap":"10px"} }
const _hoisted_38 = { class: "row full-width items-center justify-end q-pa-sm q-gutter-sm" }
const _hoisted_39 = { class: "midia-app-label-sm" }
const _hoisted_40 = { class: "row justify-end q-my-md" }

import { ref, computed, onMounted } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { useRouter } from 'vue-router';

import { EnumRouteNames, EnumButtonSizes } from '@/enums/enums';
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional';

import { useInstitutionalStore } from '@/stores/institutionalStore';
import { usePagesUtilStore } from '@/stores/pagesUtilStore';
import { useAuthStore } from '@/stores/authStore';

import BtnViewFocusedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnViewFocusedInstitutional.vue';
import BtnDeleteFocusedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnDeleteFocusedInstitutional.vue';
import BtnEditFocusedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnEditFocusedInstitutional.vue'

import ModalFilterInstitutional from '@/views/layout/modalsInstitutional/ModalFilterInstitutional.vue';
import ModalDeleteInstitutionalConfirmation from '@/views/layout/modalsInstitutional/ModalDeleteInstitutionalConfirmation.vue';
import BtnDeleteSelectedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnDeleteSelectedInstitutional.vue' // ✅


import ModalPageCampaignsTableActions
  from '@/views/modals/ModalPageCampaignsTableActions.vue';

import type { InstitutionalScreen } from '@/stores/institutionalStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageInstitutionalSearch',
  setup(__props) {

const showBtnViewFocusedCampaign = computed(() => true);
const showBtnDeleteFocusedCampaign = computed(() => true);

const formatDateBr = (date: string) => {
  if (!date) return '-'

  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

const onActionsBtnClick = (row: any) => {
  // Nenhuma ação necessária aqui por enquanto.
  // O q-popup-proxy cuida de abrir o menu.
};

const institutionalStore = useInstitutionalStore();
const pagesUtilStore = usePagesUtilStore();
const authStore = useAuthStore();

const $q = useQuasar();
const router = useRouter();

/* =====================
 * STATE
 * ===================== */
const filterTerms = ref('')
let searchTimeout: ReturnType<typeof setTimeout> | null = null

/* =====================
 * SEARCH
 * ===================== */
const onSearchInput = async (value: string) => {
  // ✅ debounce para não chamar a cada tecla
  if (searchTimeout) clearTimeout(searchTimeout)

  searchTimeout = setTimeout(async () => {
    if (value) {
      // ✅ busca no backend com o termo
      institutionalStore.institutionalFilter = { nome: value }
    } else {
      // ✅ sem termo → volta para os 10 mais recentes
      institutionalStore.resetInstitutionalFilter()
    }
    await institutionalStore.fetchInstitutionalScreens()
  }, 400)
}



/* =====================
 * TABLE
 * ===================== */
const qTableCampanhasColumns = [
  { name: 'advertiser', label: 'Cadastro de Telas', field: row => row.nome, align: 'left' },
  { name: 'name', label: 'Perfil', field: row => row.perfil, align: 'left' },
  { name: 'format', label: 'Telas', field: row => formatTelasCadastradas(row.telasCadastradas), align: 'left' },
  { name: 'startDate', label: 'Início', field: row => formatDateBr(row.dtIniVigencia), align: 'left' },
  { name: 'endDate', label: 'Fim', field: row => formatDateBr(row.dtFimVigencia), align: 'left' },
  { name: 'status', label: 'Status', field: 'status', align: 'center' },
  { name: 'statusIcon', label: '', field: 'statusIcon', align: 'center' },
  { name: 'acoes', label: 'Ações', field: 'acoes', align: 'center' }
]

const formatTelasCadastradas = (telasCadastradas: string) => {
  if (!telasCadastradas) return '-'

  const map: Record<string, string> = {
    'INICIAL': 'Telas Iniciais',
    'AGUARDE': 'Telas de Aguarde',
    'ABERTURA': 'Tela de Abertura'
  }

  return telasCadastradas
    .split(',')
    .map(t => map[t.trim()] ?? t.trim())
    .join(', ')
}


const qTableCampanhasVisibleColumns = [
  'advertiser',
  'name',
  'format',
  'startDate',
  'endDate',
  'status',
  'statusIcon',
  'acoes'
];

/* =====================
 * ACTIONS
 * ===================== */
const onFilterBtnClick = () => {
  pagesUtilStore.showModalFilterInstitutional = true;
};

const onNewInstitutionalBtnClick = () => {
  router.push({ name: EnumRouteNames.INSTITUTIONAL_NEW });
  institutionalStore.resetState();
};

/* =====================
 * FILTERED DATA
 * ===================== */
const fetchedInstitutionalsFiltered = computed(() => {
  if (!filterTerms.value) {
    return institutionalStore.institutionalScreens;
  }

  const term = filterTerms.value.toLowerCase();

  return institutionalStore.institutionalScreens.filter(item =>
    item.nome?.toLowerCase().includes(term) ||
    item.perfil?.toLowerCase().includes(term)
  );
});

/* =====================
 * STATUS LABEL
 * ===================== */
const getStatusLabel = (statusId: number) => {
  switch (statusId) {
    case CONST_INSTITUTIONAL_STATUS.HISTORICO.id:
      return 'Histórico'
    case CONST_INSTITUTIONAL_STATUS.DRAFT.id:
      return 'Rascunho'
    case CONST_INSTITUTIONAL_STATUS.ON_EDITING.id:
      return 'Em Edição'
    case CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id:
      return 'Em Aprovação'
    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id:
      return 'Ajuste Solicitado'
    case CONST_INSTITUTIONAL_STATUS.APPROVED.id:
      return 'Aprovado'
    case CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id:
      return 'Pendente Publicação'
    case CONST_INSTITUTIONAL_STATUS.PUBLISHED.id:
      return 'Publicado'
    case CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id:
      return 'Ativo'
    case CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id:
      return 'Em Reedição'
    case CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id:
      return 'Em Reaprovação'
    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id:
      return 'Reajuste Solicitado'
    case CONST_INSTITUTIONAL_STATUS.REAPPROVED.id:
      return 'Reaprovado'
    case CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id:
      return 'Concluído'
    case CONST_INSTITUTIONAL_STATUS.CANCELED.id:
      return 'Cancelado'
    default:
      return '-'
  }
}


const statusTextCssClass = (statusId: number) => {
  switch (statusId) {
    case CONST_INSTITUTIONAL_STATUS.HISTORICO.id:
      return 'status-historico'

    case CONST_INSTITUTIONAL_STATUS.APPROVED.id:
      return 'status-approved'

    case CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id:
      return 'status-approving'

    case CONST_INSTITUTIONAL_STATUS.CANCELED.id:
      return 'status-canceled'

    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id:
      return 'status-adjustments-requested'

    case CONST_INSTITUTIONAL_STATUS.ON_EDITING.id:
      return 'status-on-editing'

    case CONST_INSTITUTIONAL_STATUS.DRAFT.id:
      return 'status-draft'

    case CONST_INSTITUTIONAL_STATUS.PUBLISHED.id:
      return 'status-published'

    case CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id:
      return 'status-adjustments-requested'

    case CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id:
      return 'status-approved'

    case CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id:
      return ''

    case CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id:
      return 'status-on-editing'

    case CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id:
      return 'status-approving'

    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id:
      return 'status-adjustments-requested'

    case CONST_INSTITUTIONAL_STATUS.REAPPROVED.id:
      return 'status-approved'

    default:
      return ''
  }
}




/* =====================
 * LIFECYCLE
 * ===================== */
onMounted(async () => {
  institutionalStore.resetInstitutionalFilter();
  await institutionalStore.fetchInstitutionalScreens();
  console.log('Total:', institutionalStore.institutionalScreens.length)
});

/* =====================
 * PERMISSÕES
 * ===================== */
const canEditInstitutional = (row: any) => {
  return (
    authStore.currentUserCanEditInstitutional &&
    [
      CONST_INSTITUTIONAL_STATUS.DRAFT.id,
      CONST_INSTITUTIONAL_STATUS.ON_EDITING.id
    ].includes(row.status)
  )
}

const canDeleteInstitutional = (row: any) => {
  return (
    authStore.currentUserCanDeleteInstitutional &&
    [
      CONST_INSTITUTIONAL_STATUS.DRAFT.id,
      CONST_INSTITUTIONAL_STATUS.CANCELED.id,
      CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id,
      CONST_INSTITUTIONAL_STATUS.HISTORICO.id,
    ].includes(Number(row.status)) // ✅ converte para number
  )
}


const canReviewInstitutional = (row: any) => {
  return (
    authStore.currentUserCanReviewInstitutional &&
    row.status === CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id
  )
}

/* =====================
 * PAGINAÇÃO
 * ===================== */
const pagination = ref({
  page: 1,
  rowsPerPage: 10,
  sortBy: null,
  descending: false
})



return (_ctx: any,_cache: any) => {
  const _component_c_q_separator = _resolveComponent("c-q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_c_q_separator, { class: "q-pb-lg" }),
    _createElementVNode("div", _hoisted_1, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "q-pb-xs" }, [
        _createElementVNode("span", { class: "midia-app-label-lg" }, "Pesquise um Cadastro de Telas Institucionais")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_input, {
            id: "searchbar",
            style: {"position":"relative"},
            modelValue: filterTerms.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((filterTerms).value = $event)),
              onSearchInput
            ],
            color: "globalAppPrimaryColor",
            "bg-color": "globalAppDefaultBackgroundColor",
            outlined: "",
            dense: "",
            placeholder: "Consulte um Cadastro de Telas",
            "input-class": "midia-app-content-lg"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "search",
                class: "q-pa-sm",
                style: {"background":"var(--globalAppSecondaryColor4)","padding":"6px","position":"relative","left":"-11px","border-right":"1px solid var(--globalAppSecondaryColor2)"}
              })
            ]),
            append: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_q_btn, {
                    id: "btn-show-filterbox",
                    unelevated: "",
                    color: "globalAppDefaultBackgroundColor",
                    "text-color": "globalAppDefaultTextColor",
                    outlined: "",
                    "no-caps": "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onFilterBtnClick()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { size: "16px" }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("img", {
                            class: "svg-icon",
                            src: _imports_0
                          }, null, -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "midia-app-label-lg q-pl-sm" }, "Filtrar", -1))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_unref(authStore).currentUserCanCreateInstitutional)
            ? (_openBlock(), _createBlock(_component_c_q_btn, {
                key: 0,
                id: "btn-new-campaign",
                propBtnLabel: "Novo Cadastro",
                propBtnFunction: onNewInstitutionalBtnClick,
                propBtnTransparent: true,
                propBtnSize: _unref(EnumButtonSizes).LARGE_1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    size: "16px",
                    class: "q-pr-sm"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("img", {
                        class: "svg-icon",
                        src: _imports_1
                      }, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["propBtnSize"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "midia-app-label-sm" }, "Cadastros encontrados", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_table, {
          ref: "qTableCampanhas",
          rows: fetchedInstitutionalsFiltered.value,
          "row-key": "id",
          columns: qTableCampanhasColumns,
          "visible-columns": qTableCampanhasVisibleColumns,
          pagination: pagination.value,
          "onUpdate:pagination": _cache[8] || (_cache[8] = ($event: any) => ((pagination).value = $event)),
          "rows-per-page-options": [5, 10, 25, 50, 100],
          "hide-pagination": true,
          "no-data-label": "Nenhum registro encontrado!",
          "rows-per-page-label": "Linhas por página:",
          selection: "multiple",
          selected: _unref(institutionalStore).selectedInstitutionals,
          "onUpdate:selected": _cache[9] || (_cache[9] = ($event: any) => ((_unref(institutionalStore).selectedInstitutionals) = $event)),
          dense: _unref($q).screen.lt.md,
          flat: "",
          separator: "horizontal",
          class: "midia-app-table"
        }, {
          header: _withCtx((props) => [
            _createVNode(_component_q_tr, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_th, {
                  style: {"background":"var(--globalAppSecondaryColor4)","text-align":"center","border":"0"},
                  "auto-width": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_checkbox, {
                      modelValue: props.selected,
                      "onUpdate:modelValue": ($event: any) => ((props.selected) = $event),
                      color: (props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2'),
                      "keep-color": (!props.selected)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "keep-color"])
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                  return (_openBlock(), _createBlock(_component_q_th, {
                    key: col.name,
                    props: props,
                    style: {"background":"var(--globalAppSecondaryColor4)","border":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(col.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["props"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          body: _withCtx((props) => [
            _createVNode(_component_q_tr, {
              class: "table-body-rows",
              props: props
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_td, {
                  key: "selected",
                  style: {"text-align":"center"},
                  "auto-width": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_checkbox, {
                      modelValue: props.selected,
                      "onUpdate:modelValue": ($event: any) => ((props.selected) = $event),
                      color: (props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2'),
                      "keep-color": (!props.selected)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "keep-color"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_td, {
                  key: "advertiser",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_q_icon, { size: "24px" }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("img", {
                            class: "svg-icon",
                            src: _imports_2
                          }, null, -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(props.row.nome), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "name",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(props.row.perfil), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "format",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(formatTelasCadastradas(props.row.telasCadastradas)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "startDate",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(formatDateBr(props.row.dtIniVigencia)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "endDate",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(formatDateBr(props.row.dtFimVigencia)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "status",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", {
                        class: _normalizeClass('midia-app-label-lg ' + statusTextCssClass(props.row.status))
                      }, _toDisplayString(getStatusLabel(props.row.status)), 3)
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "statusIcon",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_q_icon, { size: "24px" }, {
                        default: _withCtx(() => [
                          ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).APPROVED.id))
                            ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                            : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).ON_APPROVAL.id))
                              ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                              : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).CANCELED.id))
                                ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                                : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).ADJUSTMENT_REQUESTED.id))
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                  : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).ON_EDITING.id))
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                                    : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).DRAFT.id))
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_26))
                                      : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).PUBLISHED.id))
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                                        : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).ON_REISSUE.id))
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                                          : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).ON_RE_APPROVAL.id))
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                                            : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).ADJUSTMENT_REQUESTED_AGAIN.id))
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_30))
                                              : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).REAPPROVED.id))
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                                                : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).INSTITUTIONAL_COMPLETED.id))
                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_32))
                                                  : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).ACTIVE_INSTITUTIONAL.id))
                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_33))
                                                    : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).PENDING_PUBLICATION.id))
                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                                                      : ((props.row.status == _unref(CONST_INSTITUTIONAL_STATUS).HISTORICO.id))
                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                                        : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          color: "white",
                          outlined: "",
                          "text-color": "black",
                          "no-caps": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              size: "24px",
                              onClick: ($event: any) => (onActionsBtnClick(props.row))
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("img", {
                                  class: "svg-icon",
                                  src: _imports_14
                                }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_q_popup_proxy, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_banner, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_card, { style: {"width":"127px","padding":"8px"} }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_37, [
                                          _createVNode(BtnViewFocusedInstitutional, {
                                            style: {"width":"100%"},
                                            id: props.row.id,
                                            propBtnSize: _unref(EnumButtonSizes).SMALL
                                          }, null, 8, ["id", "propBtnSize"]),
                                          (canEditInstitutional(props.row))
                                            ? (_openBlock(), _createBlock(BtnEditFocusedInstitutional, {
                                                key: 0,
                                                style: {"width":"100%"},
                                                id: props.row.id,
                                                propBtnSize: _unref(EnumButtonSizes).SMALL
                                              }, null, 8, ["id", "propBtnSize"]))
                                            : _createCommentVNode("", true),
                                          (canDeleteInstitutional(props.row))
                                            ? (_openBlock(), _createBlock(BtnDeleteFocusedInstitutional, {
                                                key: 1,
                                                style: {"width":"100%"},
                                                propBtnSize: _unref(EnumButtonSizes).SMALL,
                                                propInstitutionalId: props.row.id
                                              }, null, 8, ["propBtnSize", "propInstitutionalId"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          bottom: _withCtx(() => [
            _createElementVNode("div", _hoisted_38, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "midia-app-label-sm" }, "Linhas por página:", -1)),
              _createVNode(_component_q_select, {
                modelValue: pagination.value.rowsPerPage,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((pagination.value.rowsPerPage) = $event)),
                  _cache[3] || (_cache[3] = ($event: any) => (pagination.value.page = 1))
                ],
                options: [5, 10, 25, 50, 100],
                dense: "",
                outlined: "",
                style: {"width":"70px"}
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", _hoisted_39, _toDisplayString((pagination.value.page - 1) * pagination.value.rowsPerPage + 1) + "-" + _toDisplayString(Math.min(pagination.value.page * pagination.value.rowsPerPage, fetchedInstitutionalsFiltered.value.length)) + " de " + _toDisplayString(fetchedInstitutionalsFiltered.value.length), 1),
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "first_page",
                disable: pagination.value.page === 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (pagination.value.page = 1))
              }, null, 8, ["disable"]),
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "chevron_left",
                disable: pagination.value.page === 1,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (pagination.value.page--))
              }, null, 8, ["disable"]),
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "chevron_right",
                disable: pagination.value.page * pagination.value.rowsPerPage >= fetchedInstitutionalsFiltered.value.length,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (pagination.value.page++))
              }, null, 8, ["disable"]),
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "last_page",
                disable: pagination.value.page * pagination.value.rowsPerPage >= fetchedInstitutionalsFiltered.value.length,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (pagination.value.page = Math.ceil(fetchedInstitutionalsFiltered.value.length / pagination.value.rowsPerPage)))
              }, null, 8, ["disable"])
            ])
          ]),
          _: 1
        }, 8, ["rows", "pagination", "selected", "dense"])
      ])
    ]),
    _createVNode(_component_c_q_separator, { class: "q-my-md" }),
    _createElementVNode("div", _hoisted_40, [
      _createVNode(BtnDeleteSelectedInstitutional)
    ]),
    _createVNode(ModalDeleteInstitutionalConfirmation),
    _createVNode(ModalFilterInstitutional)
  ]))
}
}

})